import { useEffect, useState } from "react";
import {
    Snackbar,
    Alert,
} from "@mui/material";

const NetworkStatus = () => {
    const [online, setOnline] = useState(navigator.onLine);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setOnline(true);
            setOpen(true);
        };

        const handleOffline = () => {
            setOnline(false);
            setOpen(true);
        };

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    return (
        <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={() => setOpen(false)}
            anchorOrigin={{
                vertical: "top",
                horizontal: "center",
            }}
        >
            {online ? (
                <Alert severity="success" variant="filled">
                    Internet connection restored.
                </Alert>
            ) : (
                <Alert severity="error" variant="filled">
                    No internet connection. Please check your network.
                </Alert>
            )}
        </Snackbar>
    );
};

export default NetworkStatus;